import { useCallback } from 'react';

import { type WorkspaceMemberRoleDisplayName, type WorkspaceMemberType } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type InvitedMember = {
  location:
    | 'fat-nav'
    | 'workspace-settings'
    | 'workspace-dropdown'
    | 'header'
    | 'board'
    | 'share-link-nudge'
    | 'side-nav'
    | 'onboarding';
  role?: WorkspaceMemberRoleDisplayName;
  type?: WorkspaceMemberType;
  invitorRole?: WorkspaceMemberRoleDisplayName;
};

export const useTrackInvitedMember = () => {
  const { track } = useAnalyticsUtilities();

  const trackInvitedMember = useCallback(
    (params: InvitedMember) => {
      track(`Invited member`, params, { integrations: { 'Customer.io (Actions)': true, Intercom: true } });
    },
    [track],
  );

  return { trackInvitedMember };
};
